export default {"src":"/_next/static/media/heart.e285933b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};